export default "__VITE_ASSET__CVJZ0TEt__"